module.exports = __webpack_public_path__ + "static/media/bordertl.97a95760.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/bordertl.png
// module id = 453
// module chunks = 0